import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";

const Progress = ({ location: { pathname, state } }) => {
  const projectId = `${sessionStorage.getItem("project_id")}`;
  // const currentStage = `${sessionStorage.getItem("project_stage")}`;
  const [active, setActive] = useState("general-information");

  const isGeneralInformationStep = pathname === "/projects/create/general-information";
  const isprojectFundingStep = pathname === "/projects/create/project-funding" ;
  const isRrelatedProjectsStep = pathname === "/projects/create/related-projects";
  const isProjectLocationsStep = pathname === "/projects/create/project-locations";
  const isProjectResourcesStep = pathname === "/projects/create/project-resources";
  const isMainObjectiveStep = pathname === "/projects/create/main-objective";
  const isSpecificObjectivesStep = pathname === "/projects/create/specific-objectives";
  const isImplementingEntitiesStep = pathname === "/projects/create/implementing-entities";
  const isBeneficiaryEntitiesStep = pathname === "/projects/create/beneficiary-entities";
  const isAdditionalNotesStep = pathname === "/projects/create/additional-notes";
  const isReviewAndSubmitStep = pathname === `/projects/view/${projectId}`;
  
  const viewProject = sessionStorage.getItem("project_id");
  const [showReviewTab, setShowReviewTab] = useState(false);
  const decideToShowReviewTab=()=>{
    if(viewProject ){
      setShowReviewTab(true);
    }else{
      setShowReviewTab(false);
    }
  }
  const getCurrentStep = () => {
    // alert(pathname)
    if (isGeneralInformationStep) {
      setActive("general-information");
    } else if (isprojectFundingStep) {
      setActive("project-funding");
    } else if (isRrelatedProjectsStep) {
      setActive("related-projects");
    } else if (isProjectLocationsStep) {
      setActive("project-locations");
    } else if (isProjectResourcesStep) {
      setActive("project-resources");
    } else if (isMainObjectiveStep) {
      setActive("main-objective");
    } else if (isSpecificObjectivesStep) {
      setActive("specific-objectives");
    } else if (isImplementingEntitiesStep) {
      setActive("implementing-entities");
    } else if (isBeneficiaryEntitiesStep) {
      setActive("beneficiary-entities");
    } else if (isAdditionalNotesStep) {
      setActive("additional-notes");
    } else if (isReviewAndSubmitStep) {
      setActive("review-information");
    } else {
      setActive("general-information");
    }
  };

  useEffect(() => {
    decideToShowReviewTab();
    getCurrentStep();
  }, [pathname]);

  return (
    <React.Fragment>
      <h3 className="center-div">Create a project</h3>
      <Tabs
        activeKey={active}
        id="controlled-tab"
        onSelect={(active) => setActive(active)}
        className="mb-3 center-div"
      >
        <Tab
          eventKey="general-information"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/general-information"
            >
              General
            </Link>
          }
        />
        <Tab
          // disabled
          eventKey="project-funding"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/project-funding"
            >
              Funding
            </Link>
          }
        />
        <Tab
          eventKey="related-projects"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/related-projects"
            >
              Related Projects
            </Link>
          }
        />
        <Tab
          eventKey="project-locations"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/project-locations"
            >
              Locations
            </Link>
          }
        />
        <Tab
          eventKey="project-resources"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/project-resources"
            >
              Resources
            </Link>
          }
        />
        <Tab
          eventKey="main-objective"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/main-objective"
            >
              Main Objective
            </Link>
          }
        />
        <Tab
          eventKey="specific-objectives"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/specific-objectives"
            >
              Specific Objectives
            </Link>
          }
        />
        <Tab
          eventKey="implementing-entities"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/implementing-entities"
            >
              Implementers
            </Link>
          }
        />
        <Tab
          eventKey="beneficiary-entities"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/beneficiary-entities"
            >
              Beneficiaries
            </Link>
          }
        />
        <Tab
          eventKey="additional-notes"
          title={
            <Link
              style={{ textDecoration: "none" }}
              to="/projects/create/additional-notes"
            >
              Additional Notes
            </Link>
          }
        />
        
        {showReviewTab &&
          <Tab
            eventKey="review-information"
            title={
              <Link
                style={{ textDecoration: "none" }}
                to={`/projects/view/${projectId}`}
              >
                Review
              </Link>
            }
          />
        }
      </Tabs>
    </React.Fragment>
  );
};

export default withRouter(Progress);
